import React, { useRef, useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import GenericModal from '../../../components/agv-generic-modal';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../../enums/modal-size.enum';
import KilometersHistory from '../../../pages/Vehicles/panels/kilometers-history';
import Management from '../../../pages/Vehicles/panels/management';
import DetailsPanel from './details-panel';
import '../CreateVehicleModal/vehicle-form.css';
import '../CreateVehicleModal/create-vehicle-modal.css';
import './edit-vehicle-modal.css';

const TABS = ['Détails', 'Historique des kilomètres', 'Gestion du véhicule'];

/**
 * Modale « Modifier le véhicule » : même présentation que la modale de
 * création (sections vd-), avec l'historique des kilomètres et la gestion
 * (code PIN, QR code) dans des onglets
 */
export default function EditVehicleModal({ isOpen, setIsOpen, vehicle }) {
  const [tabIndex, setTabIndex] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const detailsRef = useRef(null);

  const close = () => {
    setIsOpen(false);
    setTabIndex(0);
  };

  const handleSave = async () => {
    const saved = await detailsRef.current?.save();
    if (saved) close();
  };

  const isDetailsTab = tabIndex === 0;
  const subtitle = [
    vehicle?.label,
    vehicle?.vehicle_type || vehicle?.vehicle_transporter_type,
    vehicle?.imat,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={(open) => !open && close()}
      title={`Modifier le véhicule ${vehicle?.vehicule_key || ''}`}
      mainAction={isDetailsTab ? handleSave : close}
      mainActionText={isDetailsTab ? 'Enregistrer' : 'Fermer'}
      mainActionIsLoading={isDetailsTab && isSaving}
      secondaryAction={isDetailsTab ? close : undefined}
      secondaryActionText={isDetailsTab ? 'Annuler' : undefined}
      size={MODAL_SIZE_STYLE[MODAL_SIZE.XL]}
    >
      {subtitle && <p className="ve-subtitle">{subtitle}</p>}
      {vehicle?.vehicule_id && (
        <TabGroup
          selectedIndex={tabIndex}
          onChange={setTabIndex}
          className="ve-tabs"
        >
          <TabList className="ve-tabs__list">
            {TABS.map((label) => (
              <Tab key={label} className="ve-tabs__tab">
                {label}
              </Tab>
            ))}
          </TabList>
          <TabPanels className="ve-tabs__panels">
            <TabPanel unmount={false}>
              <DetailsPanel
                ref={detailsRef}
                vehicleId={vehicle.vehicule_id}
                vehicleKey={vehicle.vehicule_key}
                onSavingChange={setIsSaving}
              />
            </TabPanel>
            <KilometersHistory
              vehicleId={vehicle.vehicule_id}
              isFocused={tabIndex === 1}
            />
            <Management
              vehicleId={vehicle.vehicule_id}
              vehicleKey={vehicle.vehicule_key}
              isFocused={tabIndex === 2}
            />
          </TabPanels>
        </TabGroup>
      )}
    </GenericModal>
  );
}
